var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-group-link-message" }, [
    _c("div", {
      staticClass: "message-head-link",
      domProps: { innerHTML: _vm._s(_vm.html_link) },
    }),
    _vm.chatLinksInfo && _vm.groupName
      ? _c(
          "div",
          { staticClass: "message-body", on: { click: _vm.messageBodyClick } },
          [
            _c("div", { staticClass: "group-info" }, [
              _c(
                "div",
                { staticClass: "group-info-icon" },
                [
                  _c("icon-image", {
                    attrs: { src: _vm.groupPhoto, text: _vm.groupName },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "group-info-right" }, [
                _c("div", { staticClass: "group-invitation" }, [
                  _vm._v(_vm._s(_vm.$t("chat.group-invitation-subject"))),
                ]),
                _c("div", { staticClass: "group-basic-info" }, [
                  _c("div", { staticClass: "group-name" }, [
                    _vm._v(_vm._s(_vm.groupName) + " "),
                  ]),
                  _c("div", { staticClass: "group-members-count" }, [
                    _vm._v(
                      _vm._s(_vm.$t("information.members-count")) +
                        ": " +
                        _vm._s(_vm.groupMembersCount)
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "group-join" }, [
              _c("div", { staticClass: "join-text" }, [
                _vm._v(_vm._s(_vm.$t("chat.group-join-text"))),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }